import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IShareSocial {
  /**
   * 分享的标题
   */
  shareTitle: string
  /**
   * 分享的内容
   */
  shareContent: string
  /**
   * 分享的 url
   */
  shareUrl: string
}

/**
 * 第三方社交分享
 *
 * @param {IBridgeOptions<IShareSocial>} {
 *   shareTitle = '',
 *   shareContent = '',
 *   shareUrl = '',
 *   success,
 *   fail,
 *   complete
 * }
 */
function shareSocialThirdPartySync({
  shareTitle = '',
  shareContent = '',
  shareUrl = '',
  success,
  fail,
  complete
}: IBridgeOptions<IShareSocial>) {
  const params = formatParams({
    funType: 'share',
    funName: 'shareUrl',
    shareTitle,
    shareContent,
    shareUrl
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('shareSocialThirdPartySync error: ', error)
  }
}

/**
 * 第三方社交分享
 * 一个异步接口，支持 Promise 化使用
 * @param {IBridgeOptions<IShareSocial>} {
 *   shareTitle = '',
 *   shareContent = '',
 *   shareUrl = ''
 * }
 * @returns
 */
function shareSocialThirdParty({
  shareTitle = '',
  shareContent = '',
  shareUrl = ''
}: IBridgeOptions<IShareSocial>) {
  const params = formatParams({
    funType: 'share',
    funName: 'shareUrl',
    shareTitle,
    shareContent,
    shareUrl
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }
  return nativeJSBridge(opts)
}

export { shareSocialThirdParty, shareSocialThirdPartySync }
